// @flow
import * as React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

// FIXME: decouple modal component from CWA app:
import { ClientWebApp } from 'client-web-app';

import Modal from './Modal';

let modalContainer;

declare var document: any;

export const getModalContainer = () => {
  if (modalContainer) {
    return modalContainer;
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    modalContainer = document.createElement('div');
    document.body.appendChild(modalContainer);
    return modalContainer;
  }

  throw new Error('No window or document was found to mount a modal container.');
};

export const closeModal = () => {
  const container = getModalContainer();
  unmountComponentAtNode(container);
};

type OpenModalProps = {
  closeOnBackgroundClick?: boolean,
};

export const openModal = (
  callback: (typeof closeModal) => React.Node,
  props: OpenModalProps = {},
  WrapperComponent: typeof React.Component = ClientWebApp,
) => {
  const container = getModalContainer();

  render(
    <WrapperComponent>
      <Modal
        isOpen
        onRequestClose={closeModal}
        closeOnBackgroundClick={props.closeOnBackgroundClick ?? true}
      >
        {callback(closeModal)}
      </Modal>
    </WrapperComponent>,
    container,
  );
};
